import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import light from "./theme";
import Vuetify, {
    VAlert,
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VToolbar,
    VDataTable,
    VProgressLinear,
    VAppBar,
    VBottomNavigation,
    VMain,
} from "vuetify/lib";

// vue-cli a-la-carte installation
Vue.use(Vuetify, {
    components: {
        VAlert,
        VApp,
        VNavigationDrawer,
        VFooter,
        VList,
        VBtn,
        VIcon,
        VToolbar,
        VDataTable,
        VProgressLinear,
        VAppBar,
        VBottomNavigation,
        VMain,
    },
});

const opts = {
    options: { customProperties: true },
    themes: {
        light: {
            ...light,
            // Add VTextField to set the default input text color to white
            VTextField: {
                input: {
                    color: "white",
                },
            },
        },
    },
};

export default new Vuetify(opts);
